
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5SYww", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");


var $1cuAd = parcelRequire("1cuAd");


var $fFc6D = parcelRequire("fFc6D");


var $inPa6 = parcelRequire("inPa6");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $5pCWF = parcelRequire("5pCWF");


var $6MlZq = parcelRequire("6MlZq");


var $gz8ZY = parcelRequire("gz8ZY");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $6mKj3 = parcelRequire("6mKj3");

/* MultiSelectButton.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is an entrypoint for multi-select in the content tree. It opens the BulkActionsMenu, which can be found in @confluence/page-tree */ 



var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $4NZXC = parcelRequire("4NZXC");


var $5izcQ = parcelRequire("5izcQ");


var $fVUfS = parcelRequire("fVUfS");





var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");








var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

'use no memo';
const $034345e0a3732c35$export$c59bfdf561db18cb = ()=>{
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.CONTENT_TREE_BULK_ACTIONS).BULK_ACTIONS_CHANGEBOARDING_SPOTLIGHT_DISMISSED
    ]);
    const { isBulkActionsChangeboardingSpotlightDismissed: isBulkActionsChangeboardingSpotlightDismissed } = (0, $ivb8S.deserializeState)(data);
    return {
        isBulkActionsChangeboardingSpotlightDismissed: isBulkActionsChangeboardingSpotlightDismissed
    };
};



const $23ee49304bbc1026$var$BulkActionsChangeboardingSpotlightLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gAHIm",
    name: "BulkActionsChangeboardingSpotlightLoader",
    loader: async ()=>(await (parcelRequire("cUPzL"))).BulkActionsChangeboardingSpotlightInner
});
const $23ee49304bbc1026$export$a70ab327a4760f51 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(1);
    const { isBulkActionsChangeboardingSpotlightDismissed: isBulkActionsChangeboardingSpotlightDismissed } = (0, $034345e0a3732c35$export$c59bfdf561db18cb)();
    if (isBulkActionsChangeboardingSpotlightDismissed || !(0, $9wGTI.fg)("content_tree_with_bulk_actions_changeboarding")) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23ee49304bbc1026$var$BulkActionsChangeboardingSpotlightLoader, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const { isBulkActionsChangeboardingSpotlightDismissed: isBulkActionsChangeboardingSpotlightDismissed } = (0, $034345e0a3732c35$export$c59bfdf561db18cb)();
    if (isBulkActionsChangeboardingSpotlightDismissed || !(0, $9wGTI.fg)('content_tree_with_bulk_actions_changeboarding')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23ee49304bbc1026$var$BulkActionsChangeboardingSpotlightLoader, null);
};



var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $386eff14c577d57a$export$bf2468c1c6a5e659 = ({ onClick: onClick, isDisabled: isDisabled, spaceHasUserContent: spaceHasUserContent, isMultiSelectEnabled: isMultiSelectEnabled, isLoading: isLoading, isMobile: isMobile })=>{
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hasFiredScreenEvent = (0, $42omo.useRef)(false); // only fire the screen event once when the sidebar is expanded
    (0, $42omo.useEffect)(()=>{
        const tryFireScreenEvent = ()=>{
            if ((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) === 'expanded' && !hasFiredScreenEvent.current) {
                hasFiredScreenEvent.current = true;
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'multiSelectButton'
                    }
                }).fire();
            }
        };
        tryFireScreenEvent();
        window.addEventListener('resize', tryFireScreenEvent);
        return ()=>{
            window.removeEventListener('resize', tryFireScreenEvent);
        };
    }, [
        createAnalyticsEvent
    ]);
    if (!spaceHasUserContent || isMobile || !isMultiSelectEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "content-tree-bulk-actions-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4NZXC))),
        label: intl.formatMessage($386eff14c577d57a$var$i18n.enableMultiSelect),
        appearance: "subtle",
        spacing: "compact",
        onClick: onClick,
        isTooltipDisabled: false,
        analyticsContext: {
            source: 'contentTreeBulkActions',
            attributes: {
                name: 'multiSelectButton'
            }
        },
        isDisabled: isLoading || isDisabled,
        tooltip: {
            content: isDisabled ? intl.formatMessage($386eff14c577d57a$var$i18n.disabledMultiSelectTooltipOnSearch) : undefined
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $23ee49304bbc1026$export$a70ab327a4760f51), null));
};
const $386eff14c577d57a$export$46ea206025f7f52d = ({ onClick: onClick })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        "aria-label": intl.formatMessage($386eff14c577d57a$var$i18n.exitMultiSelectLabel),
        onClick: onClick,
        xcss: $386eff14c577d57a$var$styles.exit,
        analyticsContext: {
            source: 'contentTreeBulkActions',
            attributes: {
                name: 'exitMultiSelectButton'
            }
        }
    }, intl.formatMessage($386eff14c577d57a$var$i18n.exitMultiSelect));
};
const $386eff14c577d57a$var$i18n = (0, $cgtv4.defineMessages)({
    exitMultiSelect: {
        id: "space-views.exit-multi-select",
        defaultMessage: "Exit"
    },
    exitMultiSelectLabel: {
        id: "space-views.exit-multi-select-label",
        defaultMessage: "Exit multi-select mode"
    },
    enableMultiSelect: {
        id: "space-views.enable-multi-select",
        defaultMessage: "Select multiple items to edit. Only items you have permission to modify will be affected."
    },
    disabledMultiSelectTooltipOnSearch: {
        id: "space-views.disabled-multi-select-tooltip",
        defaultMessage: "Multi-select is disabled when searching"
    }
});
const $386eff14c577d57a$var$styles = {
    exit: "_11c8fhey _18zr1b66 _1pbykb7n _4t3igktf _bfhksm61 _syaz6x5g _9oik1r31 _1bnx8stv _jf4cnqa1"
};



const $313e848f91dccb56$var$SpaceViewsMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rKir-",
    name: "SpaceViewsMenuLoader",
    loader: async ()=>(await (parcelRequire("aM6zw"))).SpaceViewsMenu
});
const $313e848f91dccb56$export$bbecd2ee2d957a01 = ({ isLicensed: isLicensed, edition: edition, selection: selection, setSelection: setSelection, spaceKey: spaceKey, expandContentSection: expandContentSection, onItemClick: onItemClick, spaceHasUserContent: spaceHasUserContent, pageTreeFinishedLoading: pageTreeFinishedLoading, isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin, spaceViewsMenuTriggerRef: spaceViewsMenuTriggerRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const canShowFolder = selection === 'TREE';
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isCreationADropdown = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const [isContextualCreateFocused, setIsContextualCreateFocused] = (0, $42omo.useState)(false);
    const [isContextualCreatePopupOpen, setIsContextualCreatePopupOpen] = (0, $42omo.useState)(false);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const [{ multiSelectMode: multiSelectMode }, { enterMultiSelect: enterMultiSelect, exitMultiSelect: exitMultiSelect }] = (0, $bwL2u.useContentTreeSelection)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const [isMobile, setIsMobile] = (0, $42omo.useState)(false);
    const mediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.md', function onChange(event) {
        // shifting between mobile and desktop
        if (isMultiSelectActive) exitMultiSelect();
        setIsMobile(event.matches);
    });
    (0, $42omo.useLayoutEffect)(()=>{
        setIsMobile(mediaQuery?.matches ?? false);
    }, [
        mediaQuery
    ]);
    const isMultiSelectEnabled = isSpaceAdminOrSuperAdmin && edition === 'PREMIUM' && (0, $6mKj3.expVal)('confluence_bulk_actions_in_content_tree', 'isEnabled', false);
    const expandSideNav = (0, $1cuAd.useExpandSideNav)();
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'contentTreeBulkActions',
                    action: 'closed',
                    actionSubject: 'bulkActionsMenu',
                    attributes: {
                        method: 'unmount'
                    }
                }
            }).fire();
            exitMultiSelect();
        };
    }, [
        createAnalyticsEvent,
        exitMultiSelect
    ]);
    const spaceViewsMenu = isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($313e848f91dccb56$var$SpaceViewsMenuLoader, {
        selection: selection,
        setSelection: setSelection,
        isWhiteboardBetaEnabled: isCreationADropdown,
        edition: edition,
        isSpaceAdminOrSuperAdmin: isSpaceAdminOrSuperAdmin,
        triggerRef: spaceViewsMenuTriggerRef
    }) : null;
    const contextualCreate = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5pCWF.ContextualCreateContentPopoverLoader), {
        isContextualCreateFocused: isContextualCreateFocused,
        setIsContextualCreateFocused: setIsContextualCreateFocused,
        shouldShowPopup: isContextualCreatePopupOpen,
        setShouldShowPopup: setIsContextualCreatePopupOpen,
        spaceKey: spaceKey,
        source: "spaceLevelContextualCreate",
        rootCreateButtonStyling: true,
        onItemClick: onItemClick,
        shouldRenderToParent: true,
        hideFolder: !canShowFolder
    }));
    const onMultiSelectClick = ()=>{
        expandSideNav();
        expandContentSection?.();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'opened',
                actionSubject: 'bulkActionsMenu',
                actionSubjectId: 'multiSelectButton'
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'multiSelectButton'
            }
        }).fire();
        enterMultiSelect();
    };
    const onExitMultiSelectClick = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'closed',
                actionSubject: 'bulkActionsMenu',
                attributes: {
                    method: 'multiSelectExitButton'
                }
            }
        }).fire();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'contentTreeBulkActions',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'multiSelectExitButton'
            }
        }).fire();
        exitMultiSelect();
    };
    const nav4Actions = isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $386eff14c577d57a$export$46ea206025f7f52d), {
        onClick: onExitMultiSelectClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isMultiSelectEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $386eff14c577d57a$export$bf2468c1c6a5e659), {
        onClick: onMultiSelectClick,
        isDisabled: multiSelectMode === (0, $bwL2u.MultiSelectMode).DISABLED,
        isLoading: !pageTreeFinishedLoading,
        spaceHasUserContent: spaceHasUserContent,
        isMultiSelectEnabled: isMultiSelectEnabled,
        isMobile: isMobile
    }), contextualCreate, !isMultiSelectEnabled && spaceViewsMenu);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        "data-vc": "pages-item-actions",
        ...ssrPlaceholderIdProp
    }, isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, nav4Actions) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, spaceViewsMenu, contextualCreate));
};
module.exports["PagesItemActions"] = $313e848f91dccb56$export$bbecd2ee2d957a01;

});

parcelRegister("1cuAd", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cvtof = parcelRequire("cvtof");

function $63281e74cccc9d52$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $42omo.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const expandSideNav = (0, $42omo.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            // Skip the re-render if it's a no-op change
            if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                mobile: currentState.mobile,
                desktop: 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            // Skip the re-render if it's a no-op change
            if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
            return {
                desktop: currentState.desktop,
                mobile: 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        setSideNavState,
        trigger
    ]);
    return expandSideNav;
}
module.exports["useExpandSideNav"] = $63281e74cccc9d52$export$e44b4744d8ff971a;

});

parcelRegister("cvtof", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $6e62a89b3ae4c955$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6e62a89b3ae4c955$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
module.exports["SideNavVisibilityState"] = $6e62a89b3ae4c955$export$eb04201bb6dd1e4e;
module.exports["SetSideNavVisibilityState"] = $6e62a89b3ae4c955$export$f6b496b07d1ea493;

});

parcelRegister("fFc6D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $bNwbD = parcelRequire("bNwbD");


var $bWLcG = parcelRequire("bWLcG");

const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $42omo.useRef)(listener);
    (0, $42omo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $fFa3V.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $1487a997836a60f3$export$49e55ae2c03d6045;

});

parcelRegister("bNwbD", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $95c4b21f9fd4bea1$export$e5c5a5f917a5871c;

});

parcelRegister("5pCWF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0d9898c9e847c9be$export$e1b8a1ae03e64401 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8AYRE",
    name: "ContextualCreateContentPopoverLoader",
    loader: async ()=>(await (parcelRequire("a4AqN"))).ContextualCreateContentPopover
});
module.exports["ContextualCreateContentPopoverLoader"] = $0d9898c9e847c9be$export$e1b8a1ae03e64401;

});

parcelRegister("a4AqN", function(module, exports) {

let $7556899598bc0153$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7556899598bc0153$var$load("hrbhL"),
    $7556899598bc0153$var$load("k8XPW"),
    $7556899598bc0153$var$load("fWCRm"),
    $7556899598bc0153$var$load("jTaSF"),
    $7556899598bc0153$var$load("6wr18"),
    $7556899598bc0153$var$load("kt4iH"),
    $7556899598bc0153$var$load("c0kqt"),
    $7556899598bc0153$var$load("k28dP"),
    $7556899598bc0153$var$load("fOF46"),
    $7556899598bc0153$var$load("iAqyW"),
    $7556899598bc0153$var$load("jbxHq"),
    $7556899598bc0153$var$load("fD0v8"),
    $7556899598bc0153$var$load("6XCf4"),
    $7556899598bc0153$var$load("1qlDN"),
    $7556899598bc0153$var$load("1yVM6"),
    $7556899598bc0153$var$load("5pvpJ"),
    $7556899598bc0153$var$load("jXx9i"),
    $7556899598bc0153$var$load("7EorR"),
    $7556899598bc0153$var$load("7u4WP"),
    $7556899598bc0153$var$load("ffEVr"),
    $7556899598bc0153$var$load("iqKwT"),
    $7556899598bc0153$var$load("iZ4sC"),
    $7556899598bc0153$var$load("hhss7"),
    $7556899598bc0153$var$load("9F7vX")
]).then(()=>parcelRequire('k9zbN'));

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("cUPzL", function(module, exports) {

let $9672b8e5de0849bf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9672b8e5de0849bf$var$load("3HpiM").then(()=>parcelRequire('dnoIM'));

});

parcelRegister("aM6zw", function(module, exports) {

let $7d837c208e5753be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7d837c208e5753be$var$load("3Bbwl"),
    $7d837c208e5753be$var$load("fC3D2")
]).then(()=>parcelRequire('a0Cao'));

});

parcelRegister("gEtAQ", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null && (0, $9wGTI.fg)('confluence_frontend_fix_page_class_route_detection')) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});


//# sourceMappingURL=PagesItemActions.62b7ac13.js.map
